import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';
import { HttpClient,HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AspRequestDetailsService {
  approveRequest: any;

  constructor(
    private http: HttpClient,
  ) { }


  requestDetails(garageKey, requestId, userKey){
    let paramData = {      
      garageKey: garageKey,
      requestId: requestId,
      userKey: userKey,
      source: "web"
    };

    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/request/details', paramData);
  }

  approveQuote(garageKey,requestId, spareRequestItems, userKey) {
    let paramData = {      
      garageKey: garageKey,
      requestId: requestId,
      spareRequestItems: spareRequestItems,
      userKey: userKey,
      status: 4,
      source: "web"
    };
    // console.log(paramData)
    // console.log("--------approve quotation----------")
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/spare/request/approve`, paramData);
  }

  submitData(payload: any) {
    const paramData=payload;
    // console.log("paramData",JSON.stringify(paramData))
    return this.http.post(`${GlobalVariable. BASE_API_URL_SPARES}/garage/customer/quote/create`, paramData);
  }

  submitDataUpdate(payload: any){
    const paramData=payload;
    // console.log('-----submitDataUpdate-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/customer/quote/update`, paramData);

  }
  searchItems(garageKey,searchWord,variantKey){
    let paramData={
      garageKey:garageKey,
      searchWord:searchWord,
      variantKey:variantKey
    }
    // console.log('-----Get Search List-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/customerQuotationSearchSuggestions`,paramData);
  // https://iapi.testpitstop.com/v1.0/pitstopspare/customerQuotationSearchSuggestions'
  }
  // displayLabourList(garageKey: string) {
  //   // const paramData = { garageKey };
  //   console.log('-----Get labour List-----------');
  //   return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}`+'/labours/'+garageKey);
  // }
  displayLabourList(garageKey: string, rateCardApplicable: string, carSize: string) {
  const payload = {
    garageKey,
    rateCardApplicable,
    carSize
  };

  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/labours`, payload, {
  });
}

  editLabour(id,labourId,garageKey,labourName,labourAmount,rateCardType,carSize,status)
  {

    let paramData={
      id:id,
      labourId:labourId,
      garageKey:garageKey,
      labourName:labourName,
      labourAmount:labourAmount,
      rateCardType: rateCardType ,
    carSize: carSize ?? null,
    status: status ?? 1,
    }
    // console.log("============rateCardType",rateCardType)
    // console.log("============carSize",carSize)
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/labour/edit`,paramData);
  }
  addLabourList(garageKey,labourName,labourAmount,rateCardType,carSize)
  {

    let paramData={
      garageKey:garageKey,
      labourName:labourName,
      labourAmount:labourAmount,
      rateCardType: rateCardType ,
    carSize: carSize ?? null
    }
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/labour/add`,paramData);
  }

  uploadSpareRequestImage(requestId: number, garageKey: string, imageFile: File) {
    const formData = new FormData();
    formData.append('file', imageFile);

    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_API_KEY}`,
      'accept': 'application/json'
    });

    const url = `${GlobalVariable.BASE_API_URL_SPARES}/spare/request/upload/image?requestId=${requestId}&garageKey=${garageKey}`;
    // console.log("PUT URL:", url);

    return this.http.put(url, formData, { headers });
  }

    deleteSpareRequestImage(garageKey: string, imageId: string) {

    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_API_KEY}`,
      'accept': 'application/json',
      'Content-Type': 'application/json'
    });

    const url = `${GlobalVariable.BASE_API_URL_SPARES}/spare/request/delete/image`;

    // console.log("DELETE IMAGE URL:", url);
    // console.log("DELETE BODY:", { garageKey, id: imageId });

    return this.http.post(url, {
      garageKey: garageKey,
      id: imageId
    }, { headers });
  }

  updateRecommendedParts(payload: any) {
    return this.http.post(
      `${GlobalVariable.BASE_API_URL_SPARES}/spare/request/recommended/parts`,
      payload
    );
  }

}
